export const PAY_TO = 'payTo';
export const TODAY = 1;
export const LAST_DAY = 0;
